import { Loader2, Search, X } from "lucide-react";

type Props = {
  value: string;
  onChange: (value: string) => void;
  onSubmit?: () => void;
  disabled?: boolean;
  busy?: boolean;
};

export function MobileInboxSearchBar({ value, onChange, onSubmit, disabled = false, busy = false }: Props) {
  const SearchIcon = busy ? Loader2 : Search;
  return (
    <div className="shrink-0 border-b border-[var(--mail-border-soft)] bg-[var(--mail-surface)] px-3 py-2">
      <label className="relative flex items-center">
        <SearchIcon
          className={`pointer-events-none absolute left-3 h-4 w-4 ${busy ? "animate-spin text-[var(--mail-accent)]" : "text-[var(--mail-muted)]"}`}
          aria-hidden
        />
        <input
          type="search"
          value={value}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") onSubmit?.();
          }}
          placeholder="Rechercher dans le dossier…"
          className="w-full rounded-full border border-[var(--mail-border-soft)] bg-[var(--mail-bg)] py-2 pl-9 pr-9 text-sm text-[var(--mail-text)] placeholder:text-[var(--mail-muted)] disabled:opacity-50"
        />
        {value ? (
          <button
            type="button"
            className="absolute right-2 flex h-7 w-7 items-center justify-center rounded-full text-[var(--mail-muted)] hover:bg-[var(--mail-surface-hover)]"
            aria-label="Effacer la recherche"
            onClick={() => onChange("")}
          >
            <X className="h-4 w-4" aria-hidden />
          </button>
        ) : null}
      </label>
    </div>
  );
}
